"use client";

import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
import { isEmail, useMessageContext } from "./message";

/**
 * Email message content component (used inside Message wrapper)
 * Renders the email subject and snippet preview
 */
export function MessageEmailContent() {
  const $ = _c(12);
  const {
    message,
    size
  } = useMessageContext();
  if (!isEmail(message)) {
    throw new Error("MessageEmailContent must be used with an email message");
  }
  const t0 = size === "sm" ? "text-caption" : "text-body";
  let t1;
  if ($[0] !== t0) {
    t1 = cx("relative", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== message.subject || $[3] !== size) {
    t2 = message.subject && <div className={cx("mb-1.5 font-semibold leading-tight text-foreground", "line-clamp-2", size === "sm" ? "text-caption" : "text-body")}>{message.subject.startsWith("Re:") ? message.subject : `Subject: ${message.subject}`}</div>;
    $[2] = message.subject;
    $[3] = size;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== message.snippet || $[6] !== size) {
    t3 = message.snippet && <div className={cx("leading-relaxed text-foreground-secondary", "line-clamp-3", size === "sm" ? "text-caption" : "text-body")}>{message.snippet}</div>;
    $[5] = message.snippet;
    $[6] = size;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}